import { sanitizeUrl } from '@braintree/sanitize-url';
import { useEffect, useMemo, useRef, useState } from 'react';
import {
  Attachment,
  Modal as StreamChatModal,
  ModalProps,
  useTranslationContext,
} from 'stream-chat-react';
import ImageGallery from 'react-image-gallery';
import ReactPlayer from 'react-player';
import ReactDOM from 'react-dom';
import 'react-image-gallery/styles/css/image-gallery.css';

const Modal = StreamChatModal as unknown as React.FC<
  React.PropsWithChildren<ModalProps>
>;

// export const Modal: React.FC<ModalProps> = (props) => {
//   const { children, onClose, open } = props;

//   const { t } = useTranslationContext('Modal');

//   const innerRef = useRef<HTMLDivElement | null>(null);
//   const closeRef = useRef<HTMLButtonElement | null>(null);

//   const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
//     if (
//       (event.target instanceof HTMLDivElement &&
//         !innerRef.current?.contains(event.target) &&
//         onClose) ||
//       (event.target instanceof HTMLButtonElement &&
//         closeRef.current?.contains(event.target) &&
//         onClose)
//     ) {
//       console.log('close')
//       onClose();
//     }
//   };

//   useEffect(() => {
//     if (!open) return () => null;

//     const handleEscKey: EventListener = (event) => {
//       if (event instanceof KeyboardEvent && event.key === 'Escape' && onClose) {
//         onClose();
//       }
//     };

//     document.addEventListener('keypress', handleEscKey);
//     return () => document.removeEventListener('keypress', handleEscKey);
//   }, [onClose, open]);

//   return (
//     // <div className={`str-chat__modal ${openClasses}`} onClick={handleClick}>
//     //   <button
//     //     className="str-chat__modal__close-button"
//     //     ref={closeRef}
//     //     title="Close"
//     //   >
//     //     {t('Close')}
//     //     <svg height="10" width="10" xmlns="http://www.w3.org/2000/svg">
//     //       <path
//     //         d="M9.916 1.027L8.973.084 5 4.058 1.027.084l-.943.943L4.058 5 .084 8.973l.943.943L5 5.942l3.973 3.974.943-.943L5.942 5z"
//     //         fillRule="evenodd"
//     //       />
//     //     </svg>
//     //   </button>
//     // <div className="str-chat__modal__inner" ref={innerRef}>
//     //   {children}
//     // </div>
//     // </div>
//     open ? ReactDOM.createPortal(
//       <div
//         className="fixed left-0 top-0 bottom-0 right-0 bg-black/80 backdrop-blur-[2px] z-10"
//         onClick={handleClick}
//       >
//         <div className="max-w-[80vw] flex items-center justify-center" ref={innerRef}>
//           <div>
//             {children}
//           </div>
//         </div>
//       </div>,
//       document.body,
//     ) : null
//   );
// };

export const ModalWrapper = (props) => {
  const { images, index, modalIsOpen, toggleModal } = props;

  return (
    <Modal onClose={toggleModal} open={modalIsOpen}>
      <ImageGallery
        items={images}
        showIndex={true}
        showPlayButton={false}
        showThumbnails={false}
        startIndex={index}
        showFullscreenButton={false}
      />
    </Modal>
  );
};

const ImageComponent = (props) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const { fallback, image_url, thumb_url } = props;
  const imageSrc = sanitizeUrl(image_url || thumb_url);
  const formattedArray = [
    {
      original: imageSrc,
      originalAlt: 'User uploaded content',
      source: imageSrc,
    },
  ];

  const toggleModal = () => setModalIsOpen(!modalIsOpen);

  return (
    <>
      <img
        alt={fallback}
        className="str-chat__message-attachment--img"
        data-testid="image-test"
        onClick={toggleModal}
        onKeyPress={toggleModal}
        src={imageSrc}
        tabIndex={0}
      />
      <ModalWrapper
        images={formattedArray}
        index={0}
        modalIsOpen={modalIsOpen}
        toggleModal={toggleModal}
      />
    </>
  );
};

const GalleryComponent = (props) => {
  const { images } = props;

  const [index, setIndex] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);

  const { t } = useTranslationContext('Gallery');

  const toggleModal = (selectedIndex: number) => {
    if (modalOpen) {
      setModalOpen(false);
    } else {
      setIndex(selectedIndex);
      setModalOpen(true);
    }
  };

  const formattedArray = useMemo(
    () =>
      images.map((image) => ({
        original: image.image_url || image.thumb_url || '',
        originalAlt: 'User uploaded content',
        source: image.image_url || image.thumb_url || '',
      })),
    [images],
  );

  const renderImages = images.slice(0, 3).map((image, i) => (
    <button
      className="str-chat__gallery-image"
      data-testid="gallery-image"
      key={`gallery-image-${i}`}
      onClick={() => toggleModal(i)}
    >
      <img
        alt="User uploaded content"
        src={image.image_url || image.thumb_url}
      />
    </button>
  ));

  return (
    <div
      className={`str-chat__gallery ${
        images.length > 3 ? 'str-chat__gallery--square' : ''
      }`}
    >
      {renderImages}
      {images.length > 3 && (
        <button
          className="str-chat__gallery-placeholder"
          onClick={() => toggleModal(3)}
          style={{
            backgroundImage: `url(${images[3].image_url})`,
          }}
        >
          <p>
            {
              t('{{ imageCount }} more', {
                imageCount: images.length - 3,
              }) as string
            }
          </p>
        </button>
      )}
      <ModalWrapper
        images={formattedArray}
        index={index}
        modalIsOpen={modalOpen}
        toggleModal={() => setModalOpen(!modalOpen)}
      />
    </div>
  );
};

export const CustomAttachment = (props) => {
  return (
    <Attachment {...props} Image={ImageComponent} Gallery={GalleryComponent} />
  );
};
